import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const BottomCorner = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='BottomCorner' {...props}>
    <polyline fill='none' stroke='#000' strokeWidth='2' points='8 20 20 20 20 8' />
  </StyledIcon>
);
